window.addEventListener('DOMContentLoaded', () => {
  const files = require.context('../../svg-icons/', false, /\.svg$/);
  files.keys().forEach(files);
});
